<template>
  <div style="width:100%;height:100%">
    <div ref="chart" style="width:100%;height:100%"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts';

export default {
  name: 'InterventionTrendChart',
  props: {
    InterventionInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      myChart: null,
      // 默认数据 - 根据设计稿需要两个系列的数据
      defaultData: {
        name: ['12-08', '12-09', '12-10', '12-11', '12-12', '12-13', '12-14', '12-15'],
        xianchangRate: [92.5, 88.3, 90.1, 87.6, 91.2, 89.5, 93.1, 88.8], // 现场识别成功率
        rengongRate: [7.5, 11.7, 9.9, 12.4, 8.8, 10.5, 6.9, 11.2]    // 人工干预率
      }
    }
  },
  mounted() {
    this.initChart();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    if (this.myChart) {
      this.myChart.dispose();
    }
    window.removeEventListener('resize', this.handleResize);
  },
  watch: {
    InterventionInfo: {
      handler(newVal) {
        if (this.myChart) {
          this.updateChart(newVal);
        }
      },
      deep: true
    }
  },
  methods: {
    initChart() {
      if (!this.$refs.chart) return;
      
      if (this.myChart) {
        this.myChart.dispose();
      }
      
      this.myChart = echarts.init(this.$refs.chart);
      this.updateChart(Object.keys(this.InterventionInfo).length > 0 ? this.InterventionInfo : this.defaultData);
    },
    
    updateChart(data) {
      if (!this.myChart) return;
      
      const name = data.name || this.defaultData.name;
      const recognitionData = data.xianchangRate || this.defaultData.xianchangRate;
      const interventionData = data.rengongRate || this.defaultData.rengongRate;
      
      const option = {
         title: {
          text: this.chartName,
          left: 'center',
          top: 20,
          textStyle: {
            color: '#333',
            fontSize: 16,
            fontWeight: 'normal'
          }
        },
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(50, 50, 50, 0.9)',
          borderColor: '#ccc',
          borderWidth: 1,
          textStyle: {
            color: '#fff'
          },
         formatter: function(params) {
            let result = `<div style="margin-bottom: 5px;">${params[0].axisValue}</div>`;
            params.forEach(item => {
              const color = item.color;
              const value = item.value;
              const seriesName = item.seriesName;
              result += `
                <div>
                  <span style="display:inline-block;margin-right:5px;width:10px;height:10px;background-color:${color};border-radius:2px;"></span>
                  <span>${seriesName}: ${value}</span>
                </div>
              `;
            });
            return result;
          }
        },
        legend: {
          data: ['现场识别成功率', '人工干预率'], // 两个图例
          top: 10,
          right: 10,
          textStyle: {
            color: '#666',
            fontSize: 12
          },
          itemWidth: 12,
          itemHeight: 12
        },
        icon:'rect',
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          top: '20%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: name,
          axisLine: {
            lineStyle: {
              color: '#D6DDEB'
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: '#464D5A',
            fontSize: 12
          }
        },
        yAxis: {
          type: 'value',
          name: '百分比(%)',
          nameTextStyle: {
            color: '#464D5A',
            fontSize: 12
          },
          min: 0,
          max: 100,
          axisLine: {
            lineStyle: {
              color: '#D6DDEB'
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: '#464D5A',
            fontSize: 12,
            formatter: '{value}%'
          },
          splitLine: {
            lineStyle: {
              color: '#F0F2F5',
              type: 'dashed'
            }
          }
        },
        series: [
          {
            name: '现场识别成功率',
            type: 'line',
            symbol: 'circle',
            symbolSize: 6,
            lineStyle: {
              width: 2,
              color: '#297DEE' // 蓝色
            },
            itemStyle: {
              color: '#297DEE'
            },
            data: recognitionData
          },
          {
            name: '人工干预率',
            type: 'line',
            symbol: 'diamond',
            symbolSize: 8,
            lineStyle: {
              width: 2,
              color: '#FF3E50' // 红色
            },
            itemStyle: {
              color: '#FF3E50'
            },
            data: interventionData
          }
        ]
      };
      
      this.myChart.setOption(option);
    },
    
    handleResize() {
      if (this.myChart) {
        this.myChart.resize();
      }
    }
  }
}
</script>